import Divider from "../../Atoms/Divider/Divider";
import Button from "../../Atoms/Button/Button";
import './GroupOfButtons.scss';

const GroupOfButtons = ({ content, formsHandler, setFormsHandler, customClass = '' }) => {
  const firstButtonHandler = () => {
    if (formsHandler.showForm1) {
      return;
    }
    setFormsHandler({
      showForm1: true,
      showForm2: false,
      showForm3: false,
      showForm4: false,
      showForm5: false,
      showForm6: false,
    });
  };
  const secondButtonHandler = () => {
    if (formsHandler.showForm2) {
      return;
    }
    setFormsHandler({
      showForm1: false,
      showForm2: true,
      showForm3: false,
      showForm4: false,
      showForm5: false,
      showForm6: false,
    });
  };
  const thirdButtonHandler = () => {
    if (formsHandler.showForm3) {
      return;
    }
    setFormsHandler({
      showForm1: false,
      showForm2: false,
      showForm3: true,
      showForm4: false,
      showForm5: false,
      showForm6: false,
    });
  };

  const fourthButtonHandler = () => {
    if (formsHandler.showForm4) {
      return;
    }
    setFormsHandler({
      showForm1: false,
      showForm2: false,
      showForm3: false,
      showForm4: true,
      showForm5: false,
      showForm6: false,
    });
  };

  const fifthButtonHandler = () => {
    if (formsHandler.showForm5) {
      return;
    }
    setFormsHandler({
      showForm1: false,
      showForm2: false,
      showForm3: false,
      showForm4: false,
      showForm5: true,
      showForm6: false,
    });
  };

  const sixthButtonHandler = () => {
    if (formsHandler.showForm6) {
      return;
    }
    setFormsHandler({
      showForm1: false,
      showForm2: false,
      showForm3: false,
      showForm4: false,
      showForm5: false,
      showForm6: true,
    });
  };

  return (
    <div>
      <div className={`tabs-buttons ${customClass}`}>
        <Button
          type={`gray ${
            formsHandler && formsHandler.showForm1 && "active"
          }`}
          content={content.first}
          clickHandler={formsHandler ? firstButtonHandler : undefined}
        />
       { 
         content.second && 
          <Button
            type={`gray ${
              formsHandler && formsHandler.showForm2 && "active"
            }`}
            content={content.second}
            clickHandler={formsHandler ? secondButtonHandler : undefined}
          />
        }
       { content.third && 
        <Button
            type={`gray ${
              formsHandler && formsHandler.showForm3 && "active"
            }`}
            content={content.third}
            className={`${formsHandler && formsHandler.showForm3 && "active"}`}
            clickHandler={formsHandler ? thirdButtonHandler : undefined}
          />
        }
        {
          content.four && 
          <Button
            type={`gray ${
              formsHandler && formsHandler.showForm4 && "active"
            }`}
            content={content.four}
            className={`${formsHandler && formsHandler.showForm4 && "active"}`}
            clickHandler={formsHandler ? fourthButtonHandler : undefined}
          />
        }
        {
          content.five && 
          <Button
            type={`gray  ${
              formsHandler && formsHandler.showForm5 && "active"
            }`}
            content={content.five}
            className={`${formsHandler && formsHandler.showForm5 && "active"}`}
            clickHandler={formsHandler ? fifthButtonHandler : undefined}
          />
        }
        {
          content.sixth && 
          <Button
            type={`gray  ${
              formsHandler && formsHandler.showForm6 && "active"
            }`}
            content={content.sixth}
            className={`${formsHandler && formsHandler.showForm6 && "active"}`}
            clickHandler={formsHandler ? sixthButtonHandler : undefined}
          />
        }
      </div>
      <Divider noSpace />
    </div>
  );
};

export default GroupOfButtons;
